import { createSelector } from 'reselect'
import sortBy from 'lodash/sortBy'

export const getWorkUploadState = state => state.WorkUploadStore

export const getWork = state => getWorkUploadState(state).work

const getMedia = state => getWorkUploadState(state).media

const getWorkVersion = state => getWorkUploadState(state).workVersion

export const getStudent = state => getWork(state) && getWork(state).student_type

export const getWorkVersionId = state => {
  const workVersion = getWorkVersion(state)
  return !workVersion ? null : workVersion.id
}

export const getWorkId = state => {
  const workVersion = getWorkVersion(state)
  return !workVersion || !workVersion.work ? null : workVersion.work.id
}

export const getMediaItems = state => {
  const stateNow = getWorkUploadState(state)
  return !stateNow.media ? {} : stateNow.media.entities.media
}

export const getMediaList = createSelector(
  [getMedia],
  media => (!media ? null : media.result.map(id => media.entities.media[id]))
)

export const getMediaListInOrder = createSelector([getMediaList], media =>
  sortBy(media, 'order')
)
